import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getEventlessFieldsQuery($id: ID!) {
    hyevent(id: $id) {
      id
      title
      maxNoOfGuests
      status
      rsvpedCount
      startAt
      endAt
    }
  }
`;
